import { render, staticRenderFns } from "./BarCodeReaderListener.vue?vue&type=template&id=42322739&"
import script from "./BarCodeReaderListener.vue?vue&type=script&lang=ts&"
export * from "./BarCodeReaderListener.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports